import angular from 'angular';

ProjectPartPopupCtrl.$inject = ['$scope'];

export function ProjectPartPopupCtrl(this: { [key: string]: any }, $scope) {
  const vm = this;
  vm.isLoaded = false;

  $scope.$watch('vm.isActive', function () {
    if (vm.isActive) {
      angular.element('.detail-card').addClass('detail-card--active');
    }
  });

  vm.close = function () {
    angular.element('.detail-card').removeClass('detail-card--active');
    vm.isActive = false;
    vm.isLoaded = false;

    // send a message to a page from an iframe embedded within it.
    //$window.parent.postMessage('navi/detail/close', $location.protocol() + '://' + $location.host());
  };

  vm.iframeLoadedCallBack = function () {
    vm.isLoaded = true;
  };
}
